import React, { useRef } from 'react';
import { Parallax } from 'react-parallax';
import { styled } from "../../stitches.config";
import { withThemeContext } from "../components/StitchesThemeProvider";
import { useWindowWidth } from '../../helpers';
import { bodyLarge, h1, h2, h4, p } from '../commonStyles/Fonts';
import Footer from "../components/Footer"

import TeamImageGrid from '../components/Career/TeamImageGrid';
import Brands from '../components/Career/Brands';
import Actions from '../components/Career/Actions';
import Jobs from '../components/Career/Jobs';
import Quotes from '../components/Career/Quotes';
import Contacts from '../components/Career/Contacts';
import Faq from '../components/Career/Faq';

import MapAnimation from '../components/Career/MapAnimation';
import CopyButton from '../components/CopyButton';

import { ReactComponent as QuoteShadow } from '../assets/icons/quote-icon.svg?react';
import { ReactComponent as FamilyShadow } from '../../assets/img/natemat/career/family.svg?react';

import officebackground from '../assets/images/contact-1.jpeg';
import teamaward from '../../assets/img/natemat/career/teamaward.webp';
import teamphoto from '../../assets/img/natemat/career/ekipa.webp';

import lis from '../../assets/img/natemat/career/lis.jpg';
import jedrzejczyk from '../../assets/img/natemat/career/jedrzejczyk.jpg';

import Avatar from '../atoms/Avatar';
import Positions from '../components/Career/Positions';

interface CareersProps {
    isDarkMode?: boolean;
}

const Careers: React.FC<CareersProps> = ({ isDarkMode }) => {

    const isDesktop = useWindowWidth() > 996;

    const jobs = useRef<HTMLDivElement | null>(null);

    const scrollToJobs = () => {
        jobs.current?.scrollIntoView({ block: "center", behavior: "smooth" });
    };

    const faqcontent = [
        {
            title: 'Jak wygląda proces rekrutacji?',
            text: 'Możesz odpowiedzieć na aktualna ofertę rekrutacyjną, ale równie dobrze możesz napisać do nas i bez niej. Następnie zapraszamy wybranych kandydatów na rozmowę rekrutacyjną: na żywo lub w formie wideokonferencji. Na początku zawsze spotykasz się z menadżerem działu, do którego aplikujesz. Jeśli stanowisko tego wymaga, w spotkaniu może uczestniczyć także menadżer działu, z którym na co dzień często będziesz mieć do czynienia. Chcemy na nim poznać Ciebie bliżej, usłyszeć o Twoim dotychczasowym doświadczeniu zawodowym i oczekiwaniach względem pracy w naTemat. Czasami zdarza się, że jest też drugi etap rekrutacji.Wtedy ponownie zapraszamy na rozmowę w szerszym gronie.Jeśli aplikujesz na stanowisko dziennikarskie, bardzo prawdopodobne, że zostaniesz poproszony o zaproponowanie tematów, które chciałbyś zrealizować jako dziennikarz, albo o napisanie tekstu próbnego. Żaden z nich nie zostanie nigdzie wykorzystany ani opublikowany.'
        },
        {
            title: 'O czym mogę pisać?',
            text: 'O wszystkim co ciekawe i aktualne. Newsy, reportaże, analizy, przeglądy, recenzje, wywiady, opinie, wideo i podcasty na naprawdę wiele tematów. Nie zamykamy się na żadną formę i tematykę. Piszemy rzetelnie zarówno o rzeczach najważniejszych, jak i tych bliskich naszemu codziennemu życiu. Pamiętaj tylko, że ważne jest, by zainteresować nią naszych czytelników.',
        },
        {
            title: 'O czym nie mogę pisać?',
            text: 'Nie ma tematów, o których u nas „nie można pisać". Musi być jedynie ciekawie i zgodnie z misją oraz wartościami Grupy naTemat. Tematy artykułów zgłaszają dziennikarze, a ostateczną decyzją o ich realizacji podejmuje wydawca dnia lub redaktor prowadzący.',
        },
    ]

    return (
        <>
            <CareerWrapper>
                <CareerHero>
                    <CareerHeroContent>
                        <h1 className={h1()}>Kariera w Grupie naTemat. Zobacz, kim jesteśmy i jak się u nas pracuje</h1>
                        <StyledButton onClick={scrollToJobs}>Sprawdź aktualne rekrutacje</StyledButton>
                    </CareerHeroContent>
                </CareerHero>
                <CareerIntro>
                    <h2 className={h2()}>Słowem wstępu...</h2>
                    <p className={p()}>Dziennikarze to jedna z grup zawodowych obarczonych najwyższym ryzykiem zachorowania na choroby cywilizacyjne. Stres, nienormowany czas pracy, zarwane na dyżurach noce i godziny spędzone przed komputerem - to właśnie te czynniki sprawiają, że praca w mediach znacząco odbija się na zdrowiu.</p>
                    <p className={p()}>Taki lub bardzo podobny opis z pewnością można znaleźć w raportach Instytutu Medycyny Pracy. I jest on dość łagodny. Pomnóż to przez pięć, dodaj codzienne zmagania z internetowymi trollami, presję czasu i niepokój, że temat "nie zażre" - wtedy w przybliżeniu będziesz wiedział, z czym je się dziennikarstwo.</p>
                    <p className={p()}>Jeśli stwierdzisz, że nie masz zamiaru żywić się w ten sposób przez całe życie, śmiało naciśnij krzyżyk w prawym górnym rogu. Jeśli jednak pomyślałeś: "Chcę wiedzieć, co sprawia, że ci masochiści się na to godzą" - czytaj dalej, bo właśnie zdałeś pierwszy test.</p>
                </CareerIntro>
                <TeamImageGrid isDesktop={isDesktop} />
                <GroupContainer>
                    <GroupWrapper>
                        <ShadowText><FamilyShadow /></ShadowText>
                        <Header>
                            <h1 className={h1()}> Poznaj Grupę naTemat </h1>
                            <p className={p()}>Jesteśmy niezależnym wydawcą internetowym o ugruntowanej pozycji na polskim rynku medialnym. Powstaliśmy w 2012 roku, a dziś nasze portale czytają co miesiąc miliony Polaków.</p>
                        </Header>
                        <Brands isDarkMode={isDarkMode} />
                    </GroupWrapper>
                    <Positions scroll={scrollToJobs} />
                    <p className={bodyLarge()} style={isDesktop ? { display: 'none' } : { display: 'block', textAlign: 'center' }}><OrangeSpan onClick={scrollToJobs}>Sprawdź aktualne rekrutacje</OrangeSpan></p>
                </GroupContainer>
                <CareerHeroVertical>
                    <h1 className={h1()}>Kreatywność, inspiracja i gra<br /> w zespole to coś, co zapewniamy<br /> i czego oczekujemy</h1>
                </CareerHeroVertical>
                <WorldContainer>
                    <OrangeCircle />
                    <h1 className={h1()}>Pracujemy nie tylko przy biurku. W naTemat jeździmy po całym świecie!</h1>
                    <MapAnimation />
                </WorldContainer>
                {/*
                <EmployersWrapper>
                    <EmployersCard>
                        <EmployersCardVideo>
                            <iframe src='https://www.youtube.com/embed/acGiQCE4ZHc' frameBorder='0' allow='autoplay; encrypted-media' ></iframe>
                        </EmployersCardVideo>
                        <EmployersCardContent>
                            <p className={p()}>Dla kogo właściwie jest praca w Grupie naTemat?</p>
                            <h2 className={h2()}>Trzeba mieć absolutne przekonanie, <OrangeSpan>że się tego naprawdę chce</OrangeSpan>!</h2>
                            <Employer>
                                <Avatar src={lis} border={true} />
                                <div>
                                    <h4 className={h4()}>Tomasz Lis</h4>
                                    <p>Właściciel Grupy naTemat</p>
                                </div>
                            </Employer>
                        </EmployersCardContent>
                    </EmployersCard>
                    <EmployersCard>
                        <EmployersCardVideo>
                            <iframe src='https://www.youtube.com/embed/x_cRL87ecHU' frameBorder='0' allow='autoplay; encrypted-media'></iframe>
                        </EmployersCardVideo>
                        <EmployersCardContent>
                            <p className={p()}>Gdzie byliśmy, gdzie jesteśmy?</p>
                            <h2 className={h2()}>Widzimy zespół, <OrangeSpan>widzimy tych młodych ludzi i duma nas rozpiera</OrangeSpan>!</h2>
                            <Employer>
                                <Avatar src={jedrzejczyk} border={true} />
                                <div>
                                    <h4 className={h4()}>Robert Jędrzejczyk</h4>
                                    <p>Właściciel Grupy naTemat</p>
                                </div>
                            </Employer>
                        </EmployersCardContent>
                    </EmployersCard>
                </EmployersWrapper>
                */ }
                <ActionsContainer>
                    <Header>
                        <h1 className={h1()}>Robimy najbardziej kreatywne rzeczy w polskim internecie</h1>
                        <p className={p()}>Nasza Grupa znana jest nie tylko z tego, że tworzy jakościowe media. Jesteśmy także najlepsi w Polsce w zaskakiwaniu... każdego z Was.</p>
                    </Header>
                    <Actions />
                </ActionsContainer>
                <AwardsContainer>
                    <Header style={{ marginLeft: isDesktop ? '20%' : '0%' }}>
                        <h1 className={h1()}>Nasze akcje doceniają nie tylko internauci, ale i branża</h1>
                        <p className={p()}>Nasze akcje otrzymują statuetki i wyróżnienia. Za pomysł z Times Square otrzymaliśmy dwie nagrody w prestiżowym konkursie MIXX Awards na najlepsze digitalowe kampanie reklamowe.</p>
                    </Header>
                    <ParallaxWrapper>
                        <Parallax bgImage={teamaward} strength={isDesktop ? 500 : 200}>
                            <div style={{ height: isDesktop ? 500 : 200 }}></div>
                        </Parallax>
                    </ParallaxWrapper>
                    <Header style={{ marginLeft: isDesktop ? '20%' : '0%' }}>
                        <h1 className={h1()}>Przeżywamy porażki razem, świętujemy sukcesy wspólnie.</h1>
                        <p className={p()}>Gdybyśmy byli korporacją, zdjęcia co ambitniejszych jednostek pewnie lądowałyby w szklanej gablocie pod szyldem "Pracownik miesiąca". Jako że nią nie jesteśmy i wychodzimy z założenia, że pochwała prezesa jest warta tyle samo, co ta udzielona sobie samemu, mamy inny sposób - dzwonimy. Tak, w naszej redakcji jest prawdziwy dzwon.</p>
                        <p className={p()}>Brzdęk metalowego serca o kopułę słychać za każdym razem, kiedy ktoś był w czymś lepszy niż poprzednio.</p>
                    </Header>
                </AwardsContainer>
                <div ref={jobs}>
                    <Jobs />
                </div>
                <QuoteContainer>
                    <h1 className={h1()}>Nasz zespół o pracy w grupie naTemat</h1>
                    <QuoteShadow />
                    <Quotes />
                </QuoteContainer>
                <TeamBanner>
                    <Header>
                        <h1 className={h1()}>Czyta nas już <OrangeSpan>co czwarty</OrangeSpan> internauta w Polsce</h1>
                        <p className={p()}>Brzmi imponująco, to fakt, ale obserwując rosnące z miesiąca na miesiąc słupki na własnej skórze sprawdzamy zasadność porzekadła o apetycie rosnącym w miarę jedzenia.</p>
                    </Header>
                    <img src={teamphoto} alt="..." />
                </TeamBanner>
                <Faq header='Więcej o pracy dla naTemat' items={faqcontent} />
                <Contacts isDesktop={isDesktop}>
                    <ContactInfo>
                        <h2 className={h2()}>Dołącz do nas!</h2>
                        <p className={p()}>Jeśli umiesz się chwalić, zrób to - najpierw w CV, a potem pierwszym zrealizowanym dla naTemat materiałem. Czekamy, aż napiszesz.</p>
                        <p className={p()}>Przed wysłaniem do nas swojego CV prosimy o zapoznanie się z informacjami dotyczącymi przetwarzania danych osobowych - <a href='https://m.natemat.pl/files/17/b7/17b77b65e891fed32e7cefeb1bc53ba7.docx' target='blank'><OrangeSpan>TUTAJ </OrangeSpan></a>
                            i <a href='https://m.natemat.pl/files/c6/2b/c62bfec876c4071751d894f2c4980644.docx' target='_blank'><OrangeSpan>TUTAJ</OrangeSpan></a>.</p>
                        <div>
                            <p className='grayparagraph'>Wyślij nam swoje CV:</p>
                            <CopyButton text='praca@natemat.pl' primary={true} />
                        </div>
                    </ContactInfo>
                </Contacts>
            </CareerWrapper>
            <Footer />
        </>
    )
}

export default withThemeContext(Careers);

const ContactInfo = styled('div', {
    padding: '16px',
    '@bp4': {
        width: '500px',
        div: {
            p: {
                color: '$grayscale50'
            },
        },
        p: {
            button: {
                '.svg-copy-icon': {
                    fill: '#FFFFFF',
                },
            }
        },
        'a:hover': {
            textDecoration: 'none',
        }
    }
})

const CareerWrapper = styled("div", {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: "$grayscale0",
    width: '100%',
    'a': {
        textDecoration: 'none',
    }
});

const CareerHero = styled("div", {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: '512px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundImage: `linear-gradient(to bottom, #131212 , transparent), url("${officebackground}")`,
    '@bp4': {
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: '578px',
        backgroundImage: `linear-gradient(to right, #131212 , transparent), url("${officebackground}")`,
        paddingLeft: '100px'
    }
});

const CareerHeroContent = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: '$grayscale0Fixed',
    width: '90%',
    textAlign: 'center',
    marginTop: "100px",
    '@bp4': {
        alignItems: 'flex-start',
        justifyContent: 'center',
        width: '670px',
        marginTop: 0,
        'h1': {
            color: '$grayscale0Fixed',
            textAlign: 'left',
        }
    }
})

const StyledButton = styled('button', {
    backgroundColor: '$primary',
    color: '$grayscale0Fixed',
    border: 'none',
    width: '90%',
    height: 'auto',
    textAlign: 'center',
    fontFamily: '$bodyLarge',
    fontSize: '16px',
    lineHeight: '24px',
    padding: '13px 20px 13px 20px',
    '@bp4': {
        width: 'auto',
        height: 'auto',
        padding: '13px 20px 13px 20px',
    }
})

const CareerIntro = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    justifySelf: 'center',
    alignSelf: 'center',
    color: '$grayscale100',
    width: '90%',
    padding: '50px 0px 50px 0px',
    '@bp4': {
        width: '50%',
        padding: '100px 0px 100px 0px',
    }
})

const OrangeSpan = styled('span', {
    color: '$natematPrimary',
})

const GroupContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '50px',
    backgroundColor: '$grayscale10',
    marginTop: '40px',
    paddingBottom: '50px',
    '&>p': {
        margin: '50px',
    },
    '@bp4': {
        marginTop: '168px',
        paddingBottom: '226px',
    }
})

const GroupWrapper = styled('div', {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '@bp4': {
        '&>div': {
            '&>svg': {
                transform: 'translateY(250px)'
            }
        }
    }
})

const WorldContainer = styled('div', {
    position: 'relative',
    backgroundColor: '$grayscale100Fixed',
    color: '$grayscale0Fixed',
    textAlign: 'left',
    'h1': {
        marginBottom: '0px',
        marginTop: '100px',
        marginLeft: '16px',
    },
    'svg': {
        position: 'absolute',
        margin: 'auto',
    },
    '@bp4': {
        textAlign: 'left',
        'h1': {
            width: '564px',
            marginLeft: "84px",
        },
        'svg': {
            position: 'absolute',
            margin: 'auto',
        }
    }
})

const Header = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    color: '$grayscale100',
    marginTop: '56px',
    marginBottom: '40px',
    textAlign: 'center',
    padding: '0px 16px 0px 16px',
    'h1': {
        margin: 0,
    },
    '@bp4': {
        width: '900px',
        marginTop: '168px',
        marginBottom: '72px',
    }
})

const CareerHeroVertical = styled('div', {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    color: '$grayscale0Fixed',
    backgroundImage: `linear-gradient(to top, #131212 , transparent), url("${officebackground}")`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: '512px',
    textAlign: 'left',
    padding: '40px 16px 64px',
    'h1': {
        width: '270px',
    },
    '@bp4': {
        "h1": {
            width: 'auto',
        },
        justifyContent: 'center',
        alignItems: 'center',
        height: '750px',
        textAlign: 'center',
    }
});

const OrangeCircle = styled('div', {
    position: 'absolute',
    backgroundColor: '$natematPrimary',
    borderRadius: '50%',
    width: '150px',
    height: '150px',
    top: '50%',
    left: '50%',
    translate: '-50% -50%',
    filter: 'blur(200px)',
    '@bp4': {
        width: '200px',
        height: '200px',
        filter: 'blur(250px)',
    }
})

const EmployersWrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '84px',
    width: '100%',
    marginTop: '64px',
    '@bp4': {
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '168px',
    }
})

const EmployersCard = styled('div', {
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: '24px',
    width: '100%',
    '@bp4': {
        flexDirection: 'row',
        justifyContent: 'center',
        width: '90%',
    }
})

const EmployersCardVideo = styled('div', {
    width: '100%',
    aspectRatio: '624/352',
    'iframe': {
        width: '100%',
        height: '100%',
    },
    '@bp4': {
        width: '624px',
        height: '352px',
        'iframe': {
            width: '100%',
            height: '100%',
        },
    }
})

const EmployersCardContent = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    color: '$grayscale100',
    width: '100%',
    padding: '16px',
    '@bp4': {
        flexDirection: 'column',
        justifyContent: 'center',
        width: '624px',
        height: '352px',
        paddingLeft: '40px',
    }
})

const Employer = styled('div', {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    'p, h4': {
        margin: '2px',
    },
    'p': {
        color: '$grayscale75',
    },
    'h4': {
        color: '$grayscale100',
    }
})

const ActionsContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '$grayscale10',
    color: '$grayscale100',
    paddingBottom: '56px',
    '@bp4': {
        paddingBottom: '168px',
    }
})

const AwardsContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    'h1, p': {
        textAlign: 'left',
    },
    'h1': {
        marginBottom: '10px',
        marginTop: '56px',
    },
    'p': {
        margin: 0,
    },
    '@bp4': {
        'h1, p': {
            textAlign: 'left',
        },
        'h1': {
            marginBottom: '10px',
        },
        'p': {
            margin: 0,
        },
    }
})

const ParallaxWrapper = styled('div', {
    alignSelf: 'center',
    width: '100%',
    'div': {
        'img': {
            height: '300px !important',
        }
    },
    '@bp4': {
        maxWidth: '1440px',
        width: '100%',
        'div': {
            'img': {
                height: 'auto !important',
            }
        }
    }
})

const QuoteContainer = styled('div', {
    position: 'relative',
    display: "flex",
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '$grayscale10',
    color: '$grayscale100',
    width: '100%',
    height: '900px',
    '& > svg': {
        position: 'absolute',
        bottom: '100px',
        right: '50px',
        opacity: 0.2,
        filter: 'grayscale(100%)',
    },
    'h1': {
        margin: '0px 10% 25px'
    },
    '@bp4': {
        '& > svg': {
            position: 'absolute',
            top: '100px',
            right: '200px',
            opacity: 0.2,
            filter: 'grayscale(100%)',
            scale: '200%',
        },
        'h1': {
            margin: '0px 10% -75px'
        },
    }

})

const TeamBanner = styled('div', {
    display: 'flex',
    alignSelf: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '90%',
    paddingBottom: '40px',
    'div': {
        gap: '0px',
    },
    'img': {
        width: '100%',
        maxWidth: '1440px',
    },
    "@bp4": {
        width: '90%',
        paddingBottom: '168px',
    }
})

const ShadowText = styled('div', {
    position: 'absolute',
    top: '25px',
    right: '0px',
    userSelect: 'none',
    'svg': {
        width: '200px',
        height: '50px',
    },
    '@bp4': {
        top: '70%',
        left: '50px',
        zIndex: 0,
        'svg': {
            width: 'max-content',
            height: '168px',
        }
    }
})